"use client";

import { Box, styled } from "@mui/material";

import MDTypography from "@/components/atoms/MDTypography";

export const HaveAnAccountLink = styled(MDTypography)`
  color: ${({ theme: { palette } }) => palette.primary.main};
  cursor: pointer;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`;

export const ChangePasswordTitle = styled(MDTypography)`
  white-space: nowrap;
  margin-bottom: ${({ theme: { margins } }) => margins.nano}px;
  color: ${({ theme: { fontColors } }) => fontColors.title};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
`;

export const ChangePasswordDescription = styled(MDTypography)`
  white-space: nowrap;
  color: ${({ theme: { fontColors } }) => fontColors.dark};
  font-size: ${({ theme: { fontSize } }) => fontSize.xxs};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  margin-bottom: ${({ theme: { margins } }) => margins.nano}px;
`;

export const PasswordRequirementsContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme: { margins } }) => margins.xxxs}px;
  margin-bottom: ${({ theme: { margins } }) => margins.nano}px;
  padding-left: ${({ theme: { margins } }) => margins.xxxs}px;
`;
export const PasswordRequirements = styled(MDTypography)`
  color: "white !important";
  font-size: ${({ theme: { fontSize } }) => fontSize.xxs};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
`;
